<template>
  <div>
    <div v-if="posts" class="row mb-8 mt-4">
      <div class="col">
        <tml-grid
          spacing="1em"
          :breakpoints="{
            xs: 1,
            md: 4,
          }"
        >
          <template v-for="post in displayPosts">
            <tml-new-pod
              v-if="post.published"
              :key="post.id"
              class="h-full"
              :title="post.title"
              :image="post.image.size('thumbnail')"
              :ratio="3 / 4"
              :href="post.url"
            />
          </template>
        </tml-grid>
      </div>
    </div>

    <div ref="intersection-observer" />
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import {formatUrl} from '@teemill/common/helpers';
import data from '../data-mixin.js';

export default {
  name: 'DisplayBlogPosts',

  mixins: [data],

  props: {
    preFetchedPosts: {
      type: Array,
    },
  },

  data() {
    return {
      meta: {},

      intersectionObserver: null,
    };
  },

  computed: {
    displayPosts() {
      return uniqBy(this.preFetchedPosts || this.posts, 'id');
    },
  },

  created() {
    window.addEventListener('scroll', this.onScroll);
  },

  mounted() {
    this.intersectionObserver = new IntersectionObserver(this.fetchContent, {
      root: null,
      rootMargin: '500px',
      threshold: 0.75,
    });

    this.intersectionObserver.observe(this.$refs['intersection-observer']);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    uniqBy,
    formatUrl,

    async fetchContent() {
      if (this.preFetchedPosts) {
        return;
      }

      this.fetchPaginatedPosts();
    },
  },
};
</script>
